import React, { Fragment } from 'react';
import { CheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
}
export function StepIndicator({
  currentStep,
  totalSteps
}: StepIndicatorProps) {
  return <div className="flex items-center justify-center mb-8" data-id="element-162">
      {Array.from({
      length: totalSteps
    }, (_, i) => i + 1).map((step, index) => <Fragment key={step} data-id="element-163">
          <div className="flex flex-col items-center" data-id="element-164">
            <motion.div initial={false} animate={{
          scale: currentStep === step ? 1.1 : 1
        }} className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold text-sm transition-all ${currentStep > step ? 'bg-green-500 text-white' : currentStep === step ? 'bg-gradient-to-r from-accent-500 to-primary-500 text-white shadow-[0_0_20px_rgba(20,184,166,0.4)]' : 'bg-slate-100 dark:bg-white/5 border border-slate-200 dark:border-white/10 text-slate-400 dark:text-slate-500'}`} data-id="element-165">
              {currentStep > step ? <CheckIcon className="w-5 h-5" data-id="element-166" /> : step}
            </motion.div>
            <span className="text-xs text-slate-500 dark:text-slate-400 mt-2" data-id="element-167">
              {step === 1 ? 'Details' : step === 2 ? 'Schedule' : 'Confirm'}
            </span>
          </div>
          {index < totalSteps - 1 && <div className={`w-16 h-0.5 mx-2 mb-6 transition-all ${currentStep > step ? 'bg-green-500' : 'bg-slate-200 dark:bg-white/10'}`} data-id="element-168" />}
        </Fragment>)}
    </div>;
}